import React from 'react';

export const ObjectNoPropsError = (props: { propKey: string }) => (
    <p>{`Schema for ${props.propKey} contains no properties and no patternProperties`}</p>
  );